"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateField = exports.validate = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _operators = _interopRequireDefault(require("./operators.js"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _index = require("../index.js");
var _Level = _interopRequireDefault(require("./Level"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _CccisdFieldWrapper = _interopRequireDefault(require("../CccisdFieldWrapper"));
var _style = _interopRequireDefault(require("./Level/style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultParams = {
  connectorName: 'data connector'
};
var _validate = exports.validate = function validate(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultParams;
  var errors = {};
  var process = function process(item, path) {
    if (!item) {
      return;
    }
    if (item.aggregation) {
      item.conditions.forEach(function (condition, index) {
        return process(condition, path ? "".concat(path, ".conditions[").concat(index, "]") : "conditions[".concat(index, "]"));
      });
    } else if (!item.dataConnector) {
      errors["".concat(path, ".dataConnector")] = "Choose ".concat(params.connectorName);
    } else if (!item.operator || item.operator === '0') {
      errors["".concat(path, ".operator")] = 'Choose operator';
    } else {
      var operatorSettings = (0, _find2["default"])(_operators["default"][item.dataConnector.type], {
        code: item.operator
      });
      if (operatorSettings.isValue) {
        if (operatorSettings.valueType === 'string' && (!item.value || item.value === '')) {
          errors["".concat(path, ".value")] = 'Enter some string';
        }
        if (operatorSettings.valueType === 'number' && item.value !== 0 && (!item.value || !(0, _isInt["default"])(item.value.toString()))) {
          errors["".concat(path, ".value")] = 'Enter valid number';
        }
      }
    }
  };
  process(values, '');
  return errors;
};
var validateField = exports.validateField = function validateField(value, params) {
  var errors = _validate(value, params);
  if ((0, _isEmpty2["default"])(errors)) {
    return null;
  }
  return Object.values(errors)[0];
};

// Force validating form on the mount
var InitialValidate = function InitialValidate(_ref) {
  var validateForm = _ref.validateForm;
  (0, _react.useEffect)(function () {
    validateForm();
  }, []);
  return null;
};
var CccisdNestedCondition = function CccisdNestedCondition(props) {
  var field = props.field,
    form = props.form,
    DataConnectorsPicker = props.DataConnectorsPicker,
    componentProps = props.componentProps;
  if (!DataConnectorsPicker) {
    return null;
  }
  var params = _objectSpread(_objectSpread({}, defaultParams), componentProps);

  // we don't want to show errors as we do that in a different way
  var formWithoutErrors = _objectSpread(_objectSpread({}, form), {}, {
    errors: {}
  });
  return /*#__PURE__*/_react["default"].createElement(_CccisdFieldWrapper["default"], _extends({}, props, {
    form: formWithoutErrors
  }), /*#__PURE__*/_react["default"].createElement(_index.Formik, {
    initialValues: field.value,
    validate: function validate(values) {
      return _validate(values, params);
    },
    onSubmit: function onSubmit() {},
    onAnyChange: function onAnyChange(values) {
      form.setFieldValue(field.name, values);
    },
    render: function render(_ref2) {
      var values = _ref2.values,
        setValues = _ref2.setValues,
        validateForm = _ref2.validateForm;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(InitialValidate, {
        validateForm: validateForm
      }), values && values.aggregation ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '-1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'flex-start'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"]["delete"],
        style: {
          paddingTop: '0.5em'
        },
        onClick: function onClick() {
          setValues(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flexGrow: 1
        }
      }, /*#__PURE__*/_react["default"].createElement(_Level["default"], {
        path: "",
        values: values,
        DataConnectorsPicker: DataConnectorsPicker,
        params: params
      })))) : /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: function onClick() {
          setValues({
            aggregation: 'all',
            conditions: [{
              id: 1,
              dataConnector: null,
              operator: '0',
              value: ''
            }]
          });
        }
      }, "Add condition"));
    }
  }));
};
CccisdNestedCondition.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  DataConnectorsPicker: _propTypes["default"].func
};
var _default = exports["default"] = CccisdNestedCondition;